/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками квартир
 */

/**
 * Сервис управления настройками квартир
 */
export class RoomServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаления настроек квартиры
   */
  DeleteRoom = (req: DeleteRoomRequestDto, init?: RequestInit): Promise<DeleteRoomResponseDto> => {
    return fm.request<DeleteRoomRequestDto, DeleteRoomResponseDto>(`${this.host}/device/api/v1/room/${encodeURIComponent(req.roomNumber)}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления списка настроек квартиры.
   * При отсутствующем или пустом фильтре удаляются все квартиры
   */
  DeleteRoomList = (req?: DeleteRoomListRequestDto, init?: RequestInit): Promise<DeleteRoomListResponseDto> => {
    return fm.request<DeleteRoomListRequestDto, DeleteRoomListResponseDto>(`${this.host}/device/api/v1/room/list`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек квартиры
   */
  GetRoom = (req: GetRoomRequestDto, init?: RequestInit): Promise<GetRoomResponseDto> => {
    return fm.request<GetRoomRequestDto, GetRoomResponseDto>(`${this.host}/device/api/v1/room/${encodeURIComponent(req.roomNumber)}${fm.buildQuery(req, ["roomNumber"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества квартир
   */
  GetRoomCount = (req?: GetRoomCountRequestDto, init?: RequestInit): Promise<GetRoomCountResponseDto> => {
    return fm.request<GetRoomCountRequestDto, GetRoomCountResponseDto>(`${this.host}/device/api/v1/room/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка настроек квартир
   */
  GetRoomList = (req?: GetRoomListRequestDto, init?: RequestInit): Promise<GetRoomListResponseDto> => {
    return fm.request<GetRoomListRequestDto, GetRoomListResponseDto>(`${this.host}/device/api/v1/room/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения настроек квартиры.
   * Поддерживает создание и обновление
   */
  SaveRoom = (req: SaveRoomRequestDto, init?: RequestInit): Promise<SaveRoomResponseDto> => {
    return fm.request<SaveRoomRequestDto, SaveRoomResponseDto>(`${this.host}/device/api/v1/room`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения списка настроек квартиры
   */
  SaveRoomList = (req?: SaveRoomListRequestDto, init?: RequestInit): Promise<SaveRoomListResponseDto> => {
    return fm.request<SaveRoomListRequestDto, SaveRoomListResponseDto>(`${this.host}/device/api/v1/room/list`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос удаления списка настроек квартиры
 */
export type DeleteRoomListRequestDto = {
  /**
   * Фильтр квартир.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ
   */
  filter?: RoomFilterRequestDto | null
}
/**
 * Ответ на запрос удаления списка настроек квартиры
 */
export type DeleteRoomListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество удаленных
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: DeleteRoomListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteRoomListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteRoomListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос удаления настроек квартиры
 */
export type DeleteRoomRequestDto = {
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Ответ на запрос удаления настроек квартиры
 */
export type DeleteRoomResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteRoomResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteRoomResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteRoomResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества квартир
 */
export type GetRoomCountRequestDto = {
}
/**
 * Ответ на запрос получения количества квартир
 */
export type GetRoomCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка настроек квартир
 */
export type GetRoomListRequestDto = {
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: RoomPagingRequestDto
}>
/**
 * Ответ на запрос получения списка настроек квартир
 */
export type GetRoomListResponseDto = {
  /**
   * Список Room
   */
  data: RoomResponseDto[]
}
/**
 * Запрос получения настроек квартиры
 */
export type GetRoomRequestDto = {
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Ответ на запрос получения настроек квартиры
 */
export type GetRoomResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Квартира
   */
  readonly data: RoomResponseDto
}>
/**
 * Квартира
 */
export type RoomRequestDto = {
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Номер Sip-переадресации вызова.
   * Диапазон: 5..200
   */
  sipForwardingNumber?: string
  /**
   * Признак блокировки аналоговой (CMS) или адресно-цифровой (digital headset) трубки
   */
  isAnalogPhoneBlocked?: boolean
}
/**
 * type
 */
& fm.OptionalOneOf<{
  /**
   * Номер координатно-матричной аналоговой трубки.
   * Где пример значения K1E9D8 - это К1 = коммутатор 1; Е9 = единицы 9; Д8 = десятки 8.
   * Паттерн: /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/
   */
  readonly analogPhoneCmsNumber: string
  /**
   * Номер цифровой трубки.
   * Диапазон: 1..255
   */
  readonly analogPhoneDigitalNumber: number
}>
/**
 * Квартира
 */
export type RoomResponseDto = {
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Номер Sip-переадресации вызова.
   * Диапазон: 5..200
   */
  sipForwardingNumber: string
  /**
   * Признак блокировки аналоговой (CMS) или адресно-цифровой (digital headset) трубки
   */
  isAnalogPhoneBlocked: boolean
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Номер координатно-матричной аналоговой трубки.
   * Где пример значения K1E9D8 - это К1 = коммутатор 1; Е9 = единицы 9; Д8 = десятки 8.
   * Паттерн: /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/
   */
  readonly analogPhoneCmsNumber: string
  /**
   * Номер цифровой трубки.
   * Диапазон: 1..255
   */
  readonly analogPhoneDigitalNumber: number
}>
/**
 * Фильтр квартир.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ
 */
export type RoomFilterRequestDto = {
  /**
   * По номерам квартир.
   * При пустом массиве удалятся все квартиры
   */
  roomNumbers?: string[]
}
/**
 * Фильтр квартир.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ
 */
export type RoomFilterResponseDto = {
  /**
   * По номерам квартир.
   * При пустом массиве удалятся все квартиры
   */
  roomNumbers: string[]
}
/**
 * Постраничный вывод
 */
export type RoomPagingRequestDto = {
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type RoomPagingResponseDto = {
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос сохранения списка настроек квартиры
 */
export type SaveRoomListRequestDto = {
  /**
   * Список Room
   */
  data?: RoomRequestDto[]
}
/**
 * Ответ на запрос сохранения списка настроек квартиры
 */
export type SaveRoomListResponseDto = {
  /**
   * Список Room
   */
  data: RoomResponseDto[]
  /**
   * Список ошибок
   */
  errors: SaveRoomListResponseErrorDto[]
}
/**
 * Ошибка запроса
 */
export type SaveRoomListResponseErrorRequestDto = {
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveRoomListResponseErrorDto = {
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос сохранения настроек квартиры
 */
export type SaveRoomRequestDto = {
  /**
   * Квартира
   */
  data: RoomRequestDto
}
/**
 * Ответ на запрос сохранения настроек квартиры
 */
export type SaveRoomResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Квартира
   */
  readonly data: RoomResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveRoomResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type SaveRoomResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveRoomResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления списка настроек квартиры
   */
  "DeleteRoomListRequest": {
    "kind": "class",
    "text": "Запрос удаления списка настроек квартиры",
    "fields": {
      /**
       * Фильтр квартир.
       * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ
       */
      "filter": {
        "type": "RoomFilter",
        "text": "Фильтр квартир.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ",
      },
    },
  },
  /**
   * Ответ на запрос удаления списка настроек квартиры
   */
  "DeleteRoomListResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления списка настроек квартиры",
    "fields": {
      /**
       * Всего количество удаленных
       */
      "data": {
        "type": "int32",
        "text": "Всего количество удаленных",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteRoomListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteRoomListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления настроек квартиры
   */
  "DeleteRoomRequest": {
    "kind": "class",
    "text": "Запрос удаления настроек квартиры",
    "fields": {
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления настроек квартиры
   */
  "DeleteRoomResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления настроек квартиры",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteRoomResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteRoomResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества квартир
   */
  "GetRoomCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества квартир",
  },
  /**
   * Ответ на запрос получения количества квартир
   */
  "GetRoomCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества квартир",
    "fields": {
      /**
       * Всего количество
       */
      "data": {
        "type": "int32",
        "text": "Всего количество",
      },
    },
  },
  /**
   * Запрос получения списка настроек квартир
   */
  "GetRoomListRequest": {
    "kind": "class",
    "text": "Запрос получения списка настроек квартир",
    "fields": {
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "RoomPaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка настроек квартир
   */
  "GetRoomListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка настроек квартир",
    "fields": {
      /**
       * Список Room
       */
      "data": {
        "type": "Room",
        "text": "Список Room",
      },
    },
  },
  /**
   * Запрос получения настроек квартиры
   */
  "GetRoomRequest": {
    "kind": "class",
    "text": "Запрос получения настроек квартиры",
    "fields": {
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения настроек квартиры
   */
  "GetRoomResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек квартиры",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Room",
        "text": "Квартира",
      },
    },
  },
  /**
   * Квартира
   */
  "Room": {
    "kind": "class",
    "text": "Квартира",
    "fields": {
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер Sip-переадресации вызова.
       * Диапазон: 5..200
       */
      "sipForwardingNumber": {
        "type": "string",
        "text": "Номер Sip-переадресации вызова.\nДиапазон: 5..200",
      },
      /**
       * Номер координатно-матричной аналоговой трубки.
       * Где пример значения K1E9D8 - это К1 = коммутатор 1; Е9 = единицы 9; Д8 = десятки 8.
       * Паттерн: /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/
       */
      "analogPhoneCmsNumber": {
        "type": "string",
        "text": "Номер координатно-матричной аналоговой трубки.\nГде пример значения K1E9D8 - это К1 = коммутатор 1; Е9 = единицы 9; Д8 = десятки 8.\nПаттерн: /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/",
      },
      /**
       * Номер цифровой трубки.
       * Диапазон: 1..255
       */
      "analogPhoneDigitalNumber": {
        "type": "int32",
        "text": "Номер цифровой трубки.\nДиапазон: 1..255",
      },
      /**
       * Признак блокировки аналоговой (CMS) или адресно-цифровой (digital headset) трубки
       */
      "isAnalogPhoneBlocked": {
        "type": "bool",
        "text": "Признак блокировки аналоговой (CMS) или адресно-цифровой (digital headset) трубки",
      },
    },
  },
  /**
   * Фильтр квартир.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ
   */
  "RoomFilter": {
    "kind": "class",
    "text": "Фильтр квартир.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ",
    "fields": {
      /**
       * По номерам квартир.
       * При пустом массиве удалятся все квартиры
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам квартир.\nПри пустом массиве удалятся все квартиры",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "RoomPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос сохранения списка настроек квартиры
   */
  "SaveRoomListRequest": {
    "kind": "class",
    "text": "Запрос сохранения списка настроек квартиры",
    "fields": {
      /**
       * Список Room
       */
      "data": {
        "type": "Room",
        "text": "Список Room",
      },
    },
  },
  /**
   * Ответ на запрос сохранения списка настроек квартиры
   */
  "SaveRoomListResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения списка настроек квартиры",
    "fields": {
      /**
       * Список Room
       */
      "data": {
        "type": "Room",
        "text": "Список Room",
      },
      /**
       * Список ошибок
       */
      "errors": {
        "type": "SaveRoomListResponse.Error",
        "text": "Список ошибок",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveRoomListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения настроек квартиры
   */
  "SaveRoomRequest": {
    "kind": "class",
    "text": "Запрос сохранения настроек квартиры",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Room",
        "text": "Квартира",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения настроек квартиры
   */
  "SaveRoomResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения настроек квартиры",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Room",
        "text": "Квартира",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveRoomResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveRoomResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}